__turbopack_context__.v({
  "checkCircle": "BookingWidget-module__7HEOyq__checkCircle",
  "checkPath": "BookingWidget-module__7HEOyq__checkPath",
  "checkWrap": "BookingWidget-module__7HEOyq__checkWrap",
  "dayChip": "BookingWidget-module__7HEOyq__dayChip",
  "draw": "BookingWidget-module__7HEOyq__draw",
  "slotChip": "BookingWidget-module__7HEOyq__slotChip",
  "slotIn": "BookingWidget-module__7HEOyq__slotIn",
  "slotOut": "BookingWidget-module__7HEOyq__slotOut",
  "stepIn": "BookingWidget-module__7HEOyq__stepIn",
});
